import { useStaticQuery, graphql } from 'gatsby'
import { parseHtmlToReact, prepareForParse } from '../../utils'

function CustomSchedule({ data: { pageContext, ...pageData } }) {
  const { pageContentfulSchedule: schedule } = pageData

  // Template 取得
  const { locale } = pageContext
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    query {
      allContentfulTemplate(
        filter: { name: { regex: "/^customSchedule.*$/" } }
      ) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
        }
      }
    }
  `)
  const templateMain = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale && node.name === 'customSchedule'
  )
  const templateElse = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale && node.name === 'customScheduleElse'
  )
  if (templateMain === undefined) {
    throw new Error(`Template not found: ${locale}`)
  }

  const { htmlBody, componentData } = prepareForParse({
    // schedule がある場合とない場合とで別の template を使う
    template: schedule ? templateMain : templateElse,
    data: {
      ...pageData,
      ...(schedule ? { contentfulSchedule: schedule } : {}),
    },
    pageContext,
  })

  return parseHtmlToReact(htmlBody, componentData)
}

export { CustomSchedule }
